// import React from "react";
// import moment from "moment";
// import { DatePicker, Space } from "antd";

// const DatePickerComponent = ({ onChange, date , customStyle }) => (
//   <Space direction="vertical" className="w-full">
//     <DatePicker 
//       onChange={onChange} 
//       className={`w-full ${customStyle}`} 
//       format="DD-MMMM-YYYY"
//       style={{ width: "100%" }}
//       value={date ? moment(date, 'DD-MMMM-YYYY') : null}
//     />
//   </Space>
// );


// export default DatePickerComponent;


import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format,  } from "date-fns";

const DatePickerComponent = ({
  onChange,
  date,
  customStyle,
  placeholder,
  size = "large",
}) => {
  const handleChange = (date) => {
    onChange(date, format(date, "dd-MMMM-yyyy")); 
  };

  return (
    <div className={`w-full ${customStyle}`}>
      <DatePicker
        selected={date}
        onChange={handleChange}
        dateFormat="dd-MMMM-yyyy"
        placeholderText={placeholder || "Select Date"}
        className={`w-full h-10 border px-3 py-1 rounded dark:text-black ${
          size === "large" ? "text-base" : "text-sm"
        }`}
        wrapperClassName="w-full"
      />
    </div>
  );
};

export default DatePickerComponent;


